import { Button, Typogaphy } from 'vnetwork-ui'
import {
    HOLIDAY_EMAIL_PRESETS,
    HolidayEmailPreset,
} from './holiday-email-presets'

interface HolidayPresetButtonsProps {
    onApply: (preset: HolidayEmailPreset) => void
}

const HolidayPresetButtons: React.FC<HolidayPresetButtonsProps> = ({
    onApply,
}) => {
    return (
        <div className="bg-amber-50 border border-amber-200 rounded-md p-3 flex items-center gap-3 flex-wrap">
            <Typogaphy className="text-sm font-medium text-amber-900">
                Mẫu nhanh VNETWORK:
            </Typogaphy>
            {HOLIDAY_EMAIL_PRESETS.map((preset) => (
                <Button
                    key={preset.id}
                    type="button"
                    variant="outlined"
                    size="small"
                    onClick={() => onApply(preset)}
                >
                    {preset.label}
                </Button>
            ))}
        </div>
    )
}

export default HolidayPresetButtons
